import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { string, node, func, bool } from 'prop-types';
import { AR } from '@one-thd/sui-icons';

const FloatingActionButton = ({
  itemId,
  text = 'See This In My Room',
  isMobile = false,
  onClick
}) => {

  return (
    <div className={`${isMobile ? 'roomvo-mobile-container--njvut' : ''}`} data-component="RoomVo">
      <div className="roomvo-container sui-w-full sm:sui-w-auto">
        <Button
          // eslint-disable-next-line max-len
          className="roomvo-stimr sui-absolute sui-top-2 sui-right-2 sui-bg-primary sui-invisible sui-btn sui-px-4 sui-rounded-full sui-shadow-xl sui-leading-normal sui-line-clamp-unset sui-normal-case sui-text-base sui-tracking-normal sui-z-10"
          data-sku={itemId}
          type="button"
          endIcon={AR}
        >
          {text}
        </Button>
      </div>
    </div>
  );
};

FloatingActionButton.propTypes = {
  itemId: string,
  text: string,
  isMobile: bool,
  onClick: func
};

FloatingActionButton.defaultProps = {
  itemId: '',
  text: 'See This In My Room',
  isMobile: false,
  onClick: () => {}
};

export default FloatingActionButton;